import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { RegistrationRedirectError } from '../../components/registration/registration.interface';

type RedirectErrorState = {
  error?: RegistrationRedirectError;
};

const initialState: RedirectErrorState = {
  error: undefined,
};

export const slice = createSlice({
  name: 'redirectError',
  initialState,
  reducers: {
    redirectError: (state, action: PayloadAction<RegistrationRedirectError>) => {
      state.error = action.payload;
    },
  },
});

export const { redirectError } = slice.actions;

export const setRedirectError =
  (error: RegistrationRedirectError): AppThunk =>
    (dispatch) => {
      dispatch(redirectError(error));
    };

export const selectRedirectError = (state: RootState) => state.redirectError.error;

export default slice.reducer;
